import { MtfElement, MtfPairing, MtfResponseInput } from '@/types/schema';

import { OptionsListItemTypeEnum } from '../../single-select/types';
import { QuizField } from '../../types';

export const isValidMtfSubmission: QuizField['isValidSubmission'] = (question, submission) =>
  submission?.mtfResponse?.length === question.mtfComponent?.leftElements.length;

export const getMtfPairingsInput = (length: number) =>
  Array(length)
    .fill(0)
    .map((_, index) => ({ leftElementIndex: index, rightElementIndices: [index] }));

export const getEmptyMtfElement = () => ({ leftElement: { text: '' }, rightElement: { text: '' } });

interface Params {
  element: MtfElement;
  selectedElementId?: string;
  isQuestionSubmitted: boolean;
  mtfResponse: MtfResponseInput[];
  correctMtfPairings?: MtfPairing[];
  side: 'left' | 'right';
}

export const getElementListItemType = (params: Params) => {
  const { element, isQuestionSubmitted, mtfResponse, correctMtfPairings, selectedElementId, side } =
    params;

  const { responsePair, correctPair } =
    side === 'left'
      ? {
          responsePair: mtfResponse.find((response) => response.leftElementId === element.id),
          correctPair: correctMtfPairings?.find((pair) => pair.leftElementId === element.id),
        }
      : {
          responsePair: mtfResponse.find((response) => response.rightElementIds[0] === element.id),
          correctPair: correctMtfPairings?.find((pair) => pair.rightElementIds[0] === element.id),
        };

  const isCorrectOption =
    side === 'left'
      ? responsePair?.rightElementIds[0] === correctPair?.rightElementIds[0]
      : responsePair?.leftElementId === correctPair?.leftElementId;

  const isAnswered = Boolean(responsePair);

  let type = isAnswered ? OptionsListItemTypeEnum.Answered : OptionsListItemTypeEnum.Default;

  if (isQuestionSubmitted) {
    if (isAnswered) {
      type = isCorrectOption ? OptionsListItemTypeEnum.Correct : OptionsListItemTypeEnum.Incorrect;
    } else {
      type = OptionsListItemTypeEnum.Missed;
    }
  }

  if (element.id === selectedElementId) {
    type = OptionsListItemTypeEnum.Selected;
  }

  return { type, responsePair };
};
